import cn from 'classnames';

import useIsScreenSize from 'js/hooks/use-is-screen-size';

import Metadata from 'components/metadata/Metadata';
import Heading from 'components/heading/Heading';
import Status from 'components/status/Status';

import { IVacancy, Status_Theme } from 'source/NFR.types';

const vacancyDateThemes: Record<number, string> = {
  [Status_Theme.None]: '',
  [Status_Theme.IsActive]: 'vacancy--date--is-active',
  [Status_Theme.IsCompleted]: 'vacancy--date--is-completed',
  [Status_Theme.ResultIsPublished]: 'vacancy--date--result-is-published',
  [Status_Theme.IsCanceled]: 'vacancy--date--is-canceled',
  [Status_Theme.IsPlanned]: 'vacancy--date--is-planned'
};

const Vacancy: React.FC<IVacancy> = ({
  dateLabel,
  date,
  mobileDate,
  year,
  status,
  title,
  metadata,
  text,
  url,
  headingLevel
}) => {
  const isDesktop = useIsScreenSize('md');

  return (
    <div className="vacancy">
      <div className="vacancy--left">
        <div className={cn('vacancy--date', status?.theme ? vacancyDateThemes[status.theme] : '')}>
          <div className="vacancy--date-label">{dateLabel}</div>
          <div className="vacancy--date-date">{isDesktop ? date : mobileDate}</div>
          <div className="vacancy--date-year">{year}</div>
        </div>
      </div>
      <div className="vacancy--right">
        {status && <Status {...status} />}
        <a className="vacancy--link" href={url}>
          <Heading className="vacancy--title" level={headingLevel}>
            <span>{title}</span>
          </Heading>
        </a>
        {metadata && <Metadata {...metadata} theme="verticalVacancies" />}
        <p className="vacancy--text">{text}</p>
      </div>
    </div>
  );
};

Vacancy.displayName = 'Vacancy';

export default Vacancy;
